<template>
  <v-app dark>
    <navbar />

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar.vue';

export default {
  name: 'App',
  components: {
    Navbar
  },
  data() {
    return {
      //
    };
  }
};
</script>
